import { render, staticRenderFns } from "./PH1V.vue?vue&type=template&id=2abb436c&scoped=true"
import script from "./PH1V.vue?vue&type=script&lang=js"
export * from "./PH1V.vue?vue&type=script&lang=js"
import style0 from "./PH1V.vue?vue&type=style&index=0&id=2abb436c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb436c",
  null
  
)

export default component.exports